import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data"]
const _hoisted_2 = ["download", "href"]

import Button from "@/components/button.vue"
  import {onBeforeMount, ref} from "vue"
  import {File as FileClient} from "@/endpoints/rutsolve/rest/file"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'document',
  props: {
    data: {
      default: null,
      required: false,
      type: String
    },
    extension: {
      default: null,
      required: false,
      type: String
    },
    title: {
      default: null,
      required: true,
      type: String
    },
    url: {
      default: null,
      required: false,
      type: String
    }
  },
  setup(__props) {

  const props = __props

  const source = ref<string>(null)

  onBeforeMount(() => {
    read()
  })

  async function read() {
    if (props.url) {
      source.value = await FileClient.read(props.url)
    } else {
      source.value = `data:application/${props.extension};base64,${props.data}`
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      (__props.extension && __props.extension.toLowerCase() == 'pdf')
        ? (_openBlock(), _createElementBlock("object", {
            key: 0,
            data: source.value
          }, null, 8, _hoisted_1))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            download: `${__props.title}.${__props.extension}`,
            href: source.value
          }, [
            _createVNode(Button, { title: "Download" })
          ], 8, _hoisted_2))
    ]),
    _: 1
  }))
}
}

})